/**
 * @fileoverview Connect the Intake route to its queue workspace.
 *
 * IntakeQueue owns list state and entry into lead detail; `IntakeLeadDetail.js`
 * owns the selected lead's actions and panels. `intakeWorkspaceState.js` preserves
 * navigation context. This wrapper owns page composition rather than a second
 * copy of queue or lead state.
 *
 * `kc-internal-backend/services/intake/__init__.py` maps backend business ownership.
 * Queue counts/previews are read models; opening this workspace does not admit
 * pipeline execution or outreach.
 */

import React from 'react'
import IntakeQueue from './IntakeQueue'
import './Intake.css'



function IntakePage() {
    return (
        <div className="intake-page">
            <div className="intake-page__body">
                <IntakeQueue />
            </div>
        </div>
    )
}

export default IntakePage
